<template>
  <div
    class="heroheaderhome"
    :class="{ 'is-open': innerIsOpen }"
  >
    <div
      class="heroheaderhome-inner"
      :class="{ 'is-open': isOpen }"
    >
      <h1 class="intro-title">
        &lsquo;{{ heroTitle }}&rsquor;
      </h1>
      <livechat
        v-if="enabledLivechat"
        :label="label"
        :i18n="i18n"
        :locale="locale"
        :web-conversations-config-id="webConversationsConfigId"
        @open="openChat"
        @close="closeChat"
      />
      <chat-entrance
        :enable-search="enableSearch"
        :links="links"
      />
    </div>
    <div class="heroheaderhome-image-wrapper">
      <img
        class="heroheaderhome-image"
        :src="heroImage"
        :alt="heroImageAlt"
        aria-hidden="true"
      >
    </div>
    <kf-curve
      :curve-is-big="true"
      curve-svg-color="white"
    />
  </div>
</template>

<script>
import TailwindMixin from '@/mixins/TailwindMixin';

export default {
  name: 'HeroHeaderHome',
  components: {
    KfCurve: () => import(/* webpackChunkName: "main" */ '@/components/base/curve/Curve.vue'),
    Livechat: () => import(/* webpackChunkName: "main" */ '@/components/livechat/Livechat.vue'),
    ChatEntrance: () =>
      import(/* webpackChunkName: "main" */ '@/components/livechat/ChatEntrance.vue'),
  },
  mixins: [TailwindMixin],
  props: {
    heroImageMobile: {
      type: String,
      default: '',
    },
    heroImageLarge: {
      type: String,
      default: '',
    },
    heroImageAlt: {
      type: String,
      default: '',
    },
    heroTitle: {
      type: String,
      default: '',
    },
    links: {
      type: Object,
      default: null,
    },
    enableSearch: {
      type: Boolean,
      default: false,
    },
    enabledLivechat: {
      type: Boolean,
      default: true,
    },
    i18n: {
      type: Object,
      default: null,
    },
    label: {
      type: String,
      default: '',
    },
    locale: {
      type: String,
      default: 'en',
    },
    webConversationsConfigId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isOpen: false,
      innerIsOpen: false,
    };
  },
  computed: {
    heroImage() {
      if (this.doesWindowHaveMinWidthXs) {
        return this.heroImageLarge;
      }
      return this.heroImageMobile;
    },
  },
  mounted() {
    if (this.enabledLivechat && this.$sessionStorage.get('isInitialized', false)) {
      this.openChat();
    }
  },
  methods: {
    openChat() {
      this.isOpen = true;
      this.innerIsOpen = true;
    },
    closeChat() {
      this.isOpen = false;
      setTimeout(() => (this.innerIsOpen = false), 600);
    },
  },
};
</script>

<style lang="postcss" scoped>
.heroheaderhome {
  @apply bg-yellow flex flex-col justify-end relative items-end pb-8;
  min-height: 550px;
  max-height: 550px;

  @screen lg {
    @apply w-full bg-transparent;
    /* object-fit: cover;
    mask-image: url('~@/assets/svg/shield-cutout.svg?inline');
    mask-size: 100%;
    mask-position: right bottom;
    mask-repeat: no-repeat; */
    min-height: 800px;
    max-height: 800px;
  }

  &.is-open {
    @apply mb-36;
  }

  .curve-container {
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
    height: auto;
    display: block;
    overflow: hidden;

    @screen lg {
      @apply hidden;
    }

    .curve {
      position: absolute;
      top: 0;
      height: 100%;
      width: 100vw;
      left: 0;
      fill: #ffffff;
      color: #ffffff;
    }
  }



  &-image {
    @apply absolute bottom-0 h-full object-cover;
    left: 43%;
    transform: translate(-50%, 0);

    @screen xl {
      transform: translate(0, 0);
      right: 0;
      left: auto;
    }

    &-wrapper {
      @screen lg {
        @apply block absolute bg-yellow h-full w-full;
        left: auto;
        transform: translate(auto, auto);
        mask-image: url('~@/assets/svg/chat-mask.svg?inline');
        mask-position: right bottom;
        mask-repeat: no-repeat;
      }
    }
  }

  .intro-title {
    @apply text-black font-playfair text-center text-4xl mb-8 font-bold bg-white p-5 pb-7 border rounded-xs;
    transition: opacity 300ms;
    right: 0;

    @screen md {
      @apply block absolute mb-0;
      font-size: 3rem;
      line-height: 3rem;
      top: -230px;
      width: 375px;
    }
  }

  &-inner {
    @apply p-0 px-4 z-10 relative;
    transition-property: transform;
    transition-duration: 300ms;
    transition-timing-function: linear;
    transition-delay: 300ms;
    width: 100%;

    @screen lg {
      @apply pb-8;
      // padding-right: 100px;
    }

    @screen xl {
      padding-right: 100px;
    }

    &.is-open {
      transform: translateY(160px);
      transition-delay: 0ms;

      @screen md {
        transform: translateY(275px);
      }

      @screen lg {
        transform: translateY(75px);
      }

      .intro-title {
        opacity: 0;
        height: 0;
      }
    }
  }
}
</style>

275px
